import styled from 'styled-components'
import { GiHamburgerMenu } from 'react-icons/gi'
import { iconSizeAndColorProps } from '../../theme/constants'

export const HamburgerMenuIcon = styled(GiHamburgerMenu).attrs(() => iconSizeAndColorProps('light'))``
